import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import {applyImpl, askImpl, bindImpl, local, mapImpl, pureImpl, rio, runRIO} from "./foreign.js";
const RIO = x => x;
const functorRIO = {map: mapImpl};
const applyRIO = {apply: applyImpl, Functor0: () => functorRIO};
const bindRIO = {bind: bindImpl, Apply0: () => applyRIO};
const applicativeRIO = {pure: pureImpl, Apply0: () => applyRIO};
const monadRIO = {Applicative0: () => applicativeRIO, Bind1: () => bindRIO};
const monadAskRIO = {ask: askImpl, Monad0: () => monadRIO};
const monadEffectRIO = {liftEffect: Unsafe$dCoerce.unsafeCoerce, Monad0: () => monadRIO};
export {RIO, applicativeRIO, applyRIO, bindRIO, functorRIO, monadAskRIO, monadEffectRIO, monadRIO};
export * from "./foreign.js";
